import { Injectable } from '@angular/core';
import { SharedServiceRegistry } from '../../../../shared/shared-service-registry';
import { SearchParams } from '../../../../shared/search/models/search-params.model';
import { DataTableConfig } from '../../../../shared/search/models/data-table-config';
import { Clause, SearchCriteria } from '../../../../shared/search/models/search-filter-model';
import { CoreServiceRegistry } from '../../../../core/core-service-registry';
import { DetailedEntityDataEditorService } from '../../../../shared/services/searchable-entity/detailed-entity/detailed-entity-data-editor.service';
import { InventoryReplenishBackendService } from './inventory-replenish-backend.service';
import { SearchEvent } from '../../../../shared/search/models/search-event';
import { InventoryReplenishDataService } from './inventory-replenish-data.service';
import { InventoryReplenishSearchService } from './inventory-replenish-search.service';
import { PropertyChangeEvent, MANUAL_EDIT } from '../../../../shared/models/property-change-event';
import { InventoryReplenishActionService } from './inventory-replenish-action.service';


@Injectable()
export class InventoryReplenishDataEditorService extends DetailedEntityDataEditorService {

    protected dataService: InventoryReplenishDataService;
    protected backendService: InventoryReplenishBackendService;
    protected searchService: InventoryReplenishSearchService;
    protected actionService: InventoryReplenishActionService;

    public replenTypeCoptions: any[];
    public replenGrpCoptions: any[];
    public detailMetadata: any[];

    constructor(protected coreServiceRegistry: CoreServiceRegistry,
        protected sharedServiceRegistry: SharedServiceRegistry) {
        super(coreServiceRegistry, sharedServiceRegistry);
    }

    // overriding this function for inventory adjustment lookup
    public createLookupParamsForColumn(property: any) {
        const lookupParams: SearchParams = new SearchParams();
        lookupParams.isFullFetch = true;
        lookupParams.columnCount = 10;
        lookupParams.defaultSearchColumn = '';
        const tableConfig: DataTableConfig = new DataTableConfig();
        tableConfig.showIdAsAHyperLink = true;
        tableConfig.supportFiltering = true;
        lookupParams.dataTableConfig = tableConfig;
        lookupParams.tableId = 'storertd';
        lookupParams.idProperty = 'storerName';
        return lookupParams;
    }

    // overriding this function for inventory adjustment
    protected createDefaultSearchCriteria(currentRow: any, selectedColumnValue: any, property: any) {
        const defaultSearchCriteria: SearchCriteria = new SearchCriteria();
        defaultSearchCriteria.conditions = [];
        defaultSearchCriteria.loadDefaultCriteria = false;
        if (property === 'Storer' || property === 'storerName') {
            const defaultCondition = this.createSearchCondition(1);
            defaultCondition.isReadOnly = false;
            defaultCondition.isMandatory = true;
            const defaultClause: Clause = new Clause();
            defaultClause.operation = '=';
            defaultClause.column = 'storerType';
            defaultClause.value = '1';
            defaultCondition.clauses = [defaultClause];
            defaultCondition.operator = 'AND';
            defaultSearchCriteria.conditions.push(defaultCondition);
        }
        return defaultSearchCriteria;
    }

    protected getLookupModalTitle(property) {
        if (property === 'storerKey') {
            return this.resourceService.get('storer_Id');
        } else {
            return property;
        }
    }
    // [LFWM-1984][Lookup screens search accordion][Added funtion to map subtitle in lookup component]
    protected getLookupModalSubTitle(property) {
        if (property === 'storerKey') {
            return this.resourceService.get('storer_Id').concat(' ').concat(this.resourceService.get('lbl_search'));
        } else {
            return property;
        }
    }

    protected getDependantMapForProperty(property: string) {
        let propMap;
        if (property === 'storerKey') {
            propMap = {
                'storerKey': 'storerName'
            };
        } else if (property === 'Storer') {
            propMap = {
                'Storer': 'storerName'
            };
        }
        return propMap;
    }

    public createDefaultSearchCriteriaforEdit(tab: string) {
        const defaultSearchCriteria = { conditions: [] };
        const zoneCondition = {
            mandatory: false,
            clauses: [],
            logicalOperation: null
        };
        const isMandatoryCondition = {
            mandatory: false,
            clauses: [],
            logicalOperation: 'AND'
        };
        if (tab === 'detail') {
            const isMandatoryClausePayload: any = {
                column: 'confirmed',
                operation: '=',
                value: 'N',
                logicalOperation: null
            };
            const isMandatoryClausePayload2: any = {
                column: 'confirmed',
                operation: '=',
                value: 'L',
                logicalOperation: 'OR'
            };
            const isMandatoryClausePayload3: any = {
                column: 'confirmed',
                operation: '=',
                value: 'S',
                logicalOperation: 'OR'
            };
            isMandatoryCondition.clauses.push(isMandatoryClausePayload);
            isMandatoryCondition.clauses.push(isMandatoryClausePayload2);
            isMandatoryCondition.clauses.push(isMandatoryClausePayload3);
        } else {
            const isMandatoryClausePayload: any = {
                column: 'confirmed',
                operation: '=',
                value: 'Y',
                logicalOperation: null
            };
            isMandatoryCondition.clauses.push(isMandatoryClausePayload);
        }
        defaultSearchCriteria.conditions.push(isMandatoryCondition);
        const fieldKeysAND: Array<string> = [
            'storerKey', 'replenishGroup', 'wavekey', 'replenType', 'facility',
        ];
        const fieldKeysOR: Array<string> = [
            'zone2', 'zone3', 'zone4', 'zone5', 'zone6', 'zone7', 'zone8', 'zone9', 'zone10', 'zone11', 'zone12'
        ];
        Object.keys(this.dataService.primaryDataMap)
            .forEach((key: string) => {
                if (fieldKeysAND.indexOf(key) > -1) {
                    if (this.dataService.primaryDataMap[key].cVal) {
                        const nonZoneCondition = {
                            mandatory: false,
                            clauses: [],
                            logicalOperation: 'AND'
                        };
                        const clausePayload: any = {
                            column: key,
                            operation: '=',
                            value: this.dataService.primaryDataMap[key].cVal,
                            logicalOperation: null
                        };
                        nonZoneCondition.clauses.push(clausePayload);
                        defaultSearchCriteria.conditions.push(nonZoneCondition);
                    }
                } else if (fieldKeysOR.indexOf(key) > -1) {
                    if (this.dataService.primaryDataMap[key].cVal) {
                        const clausePayload: any = {
                            column: key,
                            operation: '=',
                            value: this.dataService.primaryDataMap[key].cVal,
                            value1: '',
                            logicalOperation: zoneCondition.clauses.length === 0 ? null : 'OR'
                        };
                        zoneCondition.clauses.push(clausePayload);
                        // defaultSearchCriteria.conditions[1].clauses.push(clausePayload);
                    }
                }
            });

        if (zoneCondition.clauses.length > 0) {
            defaultSearchCriteria.conditions.push(zoneCondition);
        }
        const lastCondition = defaultSearchCriteria.conditions.length;
        defaultSearchCriteria.conditions[lastCondition - 1].logicalOperation = '';
        return defaultSearchCriteria;
    }

    /*This method will be called on edit mode and will populate
 lot, loc and id values for all existing line items */
    public populateRestrictedValues(pageRows: any, colName: any) {
        this.dataService.lookupMap.keyArray = ['key', 'value'];
        switch (colName) {
            case 'lot': {

                pageRows.forEach(row => {
                    let lotOptions = this.dataService.lotLineMap[row.cells['replenishKey'].cVal].lotList;
                    if (!lotOptions) {
                        lotOptions = [];
                    }
                    row.cells[colName].cOptions = lotOptions;
                });
                break;
            }

            case 'fromLoc': {
                pageRows.forEach(row => {
                    const locMap = this.dataService.lotLineMap[row.cells['replenishKey'].cVal].locMap;
                    const selectedLotValue = row.cells['lot'].cVal;
                    let locOptions = locMap[selectedLotValue];
                    if (!locOptions) {
                        locOptions = [];
                    }
                    row.cells[colName].cOptions = locOptions;
                });
                break;
            }

            case 'id': {
                pageRows.forEach(row => {
                    const locMap = this.dataService.lotLineMap[row.cells['replenishKey'].cVal].movIdMap;
                    const selectedLotValue = row.cells['lot'].cVal;
                    const selectedLocValue = row.cells['fromLoc'].cVal;
                    let locIdMap = locMap[selectedLotValue];
                    if (!locIdMap) {
                        locIdMap = {};
                    }
                    const locOptions = locIdMap[selectedLocValue];
                    row.cells[colName].cOptions = locOptions;
                });
                break;
            }
        }
    }


    public autoPopulate(row: any, colName: any) {
        if (colName === 'lot') {
            row.cells['fromLoc'].cVal = '';
            row.cells['fromLoc'].cOptions = this.dataService.lotLineMap[row.cells['replenishKey'].cVal].locMap[row.cells['lot'].cVal];
            row.cells['id'].cVal = '';
            row.cells['id'].cOptions = [];
        } else if (colName === 'fromLoc') {
            row.cells['id'].cOptions = this.dataService.lotLineMap[row.cells['replenishKey'].cVal].movIdMap[row.cells['lot'].cVal][row.cells['fromLoc'].cVal];
            row.cells['id'].cVal = '';
        }
    }

    protected handleLookupEvent(event: SearchEvent, property: any, currentColumnValue: any, currentRowCells: any) {
        this.setSelectedItemToDependantProperties(property, this.getDependantMapForProperty(property), event.selectedRow, currentRowCells);
        // LFWM-3641-if the storerKey is changed through lookup, calling the onStorerChange. 
        if (property === 'storerKey') {
            this.actionService.onStorerChange(event.selectedItemId);
        }
    }
    // [LFWM-2736][To calculate the total when the columns cases and eaches are edited]
    public propertyValueChanged(event: PropertyChangeEvent): boolean {

        /* if we are  making a field null then event.value = '', but it should return true, so removing
        (event.type === MANUAL_EDIT && event.value )*/
        let qtyavailable: number;
        if (event.type === MANUAL_EDIT) {
            if (event.property === 'cases' || event.property === 'eaches') {
                const packval = event.row.cells['packKey'].cVal;
                const request = {

                    'fromLoc': event.row.cells['fromLoc'].cVal,
                    'lot': event.row.cells['lot'].cVal,
                    'id': event.row.cells['id'].cVal
                };
                this.backendService.fetchQuantityAvailable(request).subscribe((resp: any) => {
                    if (resp && resp['qtyAvailable']) {
                        qtyavailable = resp['qtyAvailable'];
                        if (event.value >= 0) {
                            this.backendService.fetchCaseCountPackkey(packval).subscribe((res: any) => {
                                let total: number;
                                if (res && res['caseCnt']) {
                                    if (event.property === 'cases') {
                                        total = (event.value * res['caseCnt']) + Number(event.row.cells['eaches'].cVal);
                                    } else {
                                        total = (event.row.cells['cases'].cVal * res['caseCnt']) + Number(event.value);
                                    }
                                }
                                // To check whether Total<=Quantity available
                                if (total <= qtyavailable) {
                                    event.row.cells['total'].cVal = total.toString();
                                    // To refresh the grid after calculating the total
                                    this.dataService.tabbedSearchServices[0].getPagedData().aggridApi.refreshCells({ force: true });
                                } else {
                                    this.alertService.clearAll().error(this.resourceService.get('msg_error_qty_greater_available') + qtyavailable);
                                    event.row.cells['cases'].cVal = event.row.cells['cases'].cValOrig;
                                    event.row.cells['eaches'].cVal = event.row.cells['eaches'].cValOrig;
                                    event.row.cells['total'].cVal = event.row.cells['total'].cValOrig;
                                    // To refresh the grid after resetting cases, eaches and total when the total is more than quantity available
                                    this.dataService.tabbedSearchServices[0].getPagedData().aggridApi.refreshCells({ force: true });
                                }

                            }, (error: any) => {
                                if (error) {
                                    this.alertService.clearAll().error(this.resourceService.translateServerResponse(error));

                                }
                            });
                        }
                    }
                }, (error: any) => {
                    if (error) {
                        this.alertService.clearAll().error(this.resourceService.translateServerResponse(error));
                    }
                });
            }
            return true;
        }
    }
}





// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/1_SCE_CI_CD_SIT/src/app/features/inventory/inventory-replenish/services/inventory-replenish-data-editor.service.ts